import { supabase } from "@/supabase";

export async function carregarCriteriosRubrica(){
    const {data, error} = await supabase
    .from('criterios_rubrica')
    .select('id, criterio')

    if(error){
        console.log(error.message)
    }

    return data;
}